import { prop, ComponentEventBus, inject } from "fw";

let uniqueId = 0;

@inject
export class TextField {
    constructor(private ceb: ComponentEventBus) {}

    @prop(null) label: string;
    @prop("") placeholder: string;
    @prop(null) value: string;
    @prop(null) validation: string;
    @prop(true) showValidation?: boolean;
    @prop(false) disabled: boolean;
    @prop("") cssClass: string;
    @prop(null) public type!: "date" | "email" | "tel" | "text" | "password" | "number" | "url";
    @prop(null) dataId: string;
    @prop(null) public autocomplete: string;

    private uniqueId = uniqueId++;

    get id() {
        return `${this.label ? this.label.replace(/\s/g, "") : this.placeholder ? this.placeholder.replace(/[^a-zA-Z]/g, "") : ""}-tf-${this.uniqueId}`;
    }

    get pValue() {
        return this.value;
    }

    set pValue(val: string) {
        this.ceb.updateModel(val);
        this.ceb.dispatch("update:value", val);
    }

    public onKeyUp() {
        this.ceb.dispatch("keyup");
    }
}
